var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpecification(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 12H65a3 3 0 013 3v59a3 3 0 01-3 3H15a3 3 0 01-3-3V15a3 3 0 013-3h16m18.5 0v1a3 3 0 01-3 3H34a3 3 0 01-3-3v-1m18.5 0V9.488A2.488 2.488 0 0047.012 7v0c-1.174 0-2.144-.846-2.633-1.912-2.065-4.504-7.116-4.051-9.337.526C34.656 6.409 33.897 7 33.013 7v0A2.013 2.013 0 0031 9.013V12",
    stroke: "#504FE9",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 44.5h29M30.5 36h29M30.5 26h29",
    stroke: "#504FE9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 46a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM21.5 37a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM21.5 27a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
    fill: "#504FE9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 54h-33a2 2 0 00-2 2v10a2 2 0 002 2h33a2 2 0 002-2V56a2 2 0 00-2-2z",
    stroke: "#504FE9",
    strokeWidth: 2
  })));
}
export default SvgSpecification;